import { createRoot } from "react-dom/client";
import { Analytics } from "@vercel/analytics/react";
import App from "./App.tsx";
import "./index.css";
import "./App.css";
import { suppressProductionLogs } from "./utils/logger";
import { sanitizeAnalyticsEvent } from "./lib/funnelAnalytics";

// Suppress verbose logs in production for security
suppressProductionLogs();

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Analytics beforeSend={sanitizeAnalyticsEvent} debug={false} />
  </>,
);
